import React from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";

export const MarketingHeader = () => {
  const [open, setOpen] = React.useState(false);
  const { merchant } = useAuth();

  return (
    <header className="sticky top-0 z-40 glass-header border-b border-gray-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo size="sm" />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600">
          <a href="/#fitur" className="hover:text-gray-900 transition-colors" data-testid="nav-features">Fitur</a>
          <a href="/#cara-kerja" className="hover:text-gray-900 transition-colors" data-testid="nav-how">Cara Kerja</a>
          <Link to="/pricing" className="hover:text-gray-900 transition-colors" data-testid="nav-pricing">Harga</Link>
          <a href="/#testimoni" className="hover:text-gray-900 transition-colors" data-testid="nav-testimonials">Testimoni</a>
        </nav>
        <div className="hidden md:flex items-center gap-2">
          {merchant ? (
            <Link to="/dashboard">
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="nav-dashboard-btn">Buka Dashboard</Button>
            </Link>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" data-testid="nav-login-btn">Masuk</Button>
              </Link>
              <Link to="/signup">
                <Button className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="nav-signup-btn">Daftar Gratis</Button>
              </Link>
            </>
          )}
        </div>
        <button
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-gray-200 bg-white px-4 py-4 flex flex-col gap-3">
          <a href="/#fitur" className="text-gray-700" onClick={() => setOpen(false)}>Fitur</a>
          <a href="/#cara-kerja" className="text-gray-700" onClick={() => setOpen(false)}>Cara Kerja</a>
          <Link to="/pricing" className="text-gray-700" onClick={() => setOpen(false)}>Harga</Link>
          <div className="flex gap-2 pt-2">
            {merchant ? (
              <Link to="/dashboard" className="flex-1">
                <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">Buka Dashboard</Button>
              </Link>
            ) : (
              <>
                <Link to="/login" className="flex-1"><Button variant="outline" className="w-full">Masuk</Button></Link>
                <Link to="/signup" className="flex-1"><Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">Daftar</Button></Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export const MarketingFooter = () => (
  <footer className="border-t border-gray-200 bg-gray-50/50 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
      <div className="col-span-2 md:col-span-2">
        <Logo />
        <p className="mt-4 text-sm text-gray-600 max-w-md leading-relaxed">
          Platform Customer Ownership untuk UMKM & seller marketplace. Ubah pembeli Shopee, TikTok Shop, dan Tokopedia menjadi pelanggan milik brand Anda.
        </p>
      </div>
      <div>
        <div className="text-xs font-bold tracking-wider uppercase text-emerald-600 mb-3">Produk</div>
        <ul className="space-y-2 text-sm text-gray-600">
          <li><a href="/#fitur" className="hover:text-gray-900">Fitur</a></li>
          <li><Link to="/pricing" className="hover:text-gray-900">Harga</Link></li>
          <li><a href="/#cara-kerja" className="hover:text-gray-900">Cara Kerja</a></li>
        </ul>
      </div>
      <div>
        <div className="text-xs font-bold tracking-wider uppercase text-emerald-600 mb-3">Perusahaan</div>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>Tentang</li>
          <li>Blog</li>
          <li>Kontak</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-gray-200 py-6 text-center text-xs text-gray-500">
      © 2026 Custora. Made in Indonesia untuk UMKM.
    </div>
  </footer>
);
